<template>
  <div class="dashboard-menu">
    <ul>
      <li><router-link :to="{ name: 'RegisteredProducts'}">Registered Products</router-link></li>
      <li><router-link :to="{ name: 'Resellers'}">Reseller</router-link></li>
      <li><router-link :to="{ name: 'Customers'}">Customers</router-link></li>
      <li><router-link :to="{ name: 'EditProfile'}">Edit Profile</router-link></li>
      <li><a href="#" @click.prevent="logout()">Logout</a></li>
    </ul>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    name: 'DashboardMenu',
    data() {
      return { 
       
      }
    },
    methods:{
      logout() {


        
        this.$store.dispatch('clearAppData'); 
        this.$router.push({ name: "Login"});
        this.snackbar({
          message: "Successfully Logged out....",
          type: "success"
        })
      },
    },
    ...mapActions({
    })
  }
</script>